import React, { useContext, useEffect, useState } from 'react';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar';
import Label from '@components/obsolete/Form/Label/Label';
import { InputText } from 'primereact/inputtext';
import { ApiContext } from '@api/api';
import * as yup from 'yup';
import useValidation from '@hooks/validation-hook/useValidation';
import ValidationDiv from '@utils/validation';
import { useTranslation } from 'react-i18next';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  templateId: string;
  onComplete: (templateName: string) => void;
}

interface InternalInformationForm {
  responsiblePerson: any;
}

const EditName: React.FC<ComponentProps> = ({ visible, onHide, templateId, onComplete }) => {
  const { t } = useTranslation('common');
  const { cuGetEditTemplateName } = useContext(ApiContext);
  const [templateName, setTemplateName] = useState<string>(undefined);

  useEffect(() => {
    if (visible)
      cuGetEditTemplateName(templateId, data => {
        setTemplateName(data.templateName);
      });
    clear();
  }, [visible]);

  const schema = yup.string().required();
  const { clear, validationErrors, validateAndSend } = useValidation(schema, () => onComplete(templateName));

  return (
    <>
      {/*
        // @ts-ignore*/}
      <RingilSidebar
        visible={visible}
        size={'md'}
        heading={t(`EditName.changeTemplateName`, `Změna názvu trasy`)}
        onContinue={() => validateAndSend(templateName)}
        onBack={() => onHide()}
        continueLabel={t('labelSave')}
      >
        <div className="p-field">
          <Label title={`${t('EditName.name', 'Název')} *`} />
          <div className="p-inputgroup">
            <InputText value={templateName} onChange={e => setTemplateName((e.target as HTMLInputElement).value)} />
          </div>
          <ValidationDiv errors={validationErrors} path={''} />
        </div>
      </RingilSidebar>
    </>
  );
};

export default EditName;
